export default __webpack_public_path__ + "static/media/checkMark.cc287b7d.svg";